import { Component, OnInit } from '@angular/core';
import { UnitPublicService } from 'app/services/public/unit-public.service';
import {FileDownloaderUtils} from '../../../services/file-downloader.utils';
import { LandingLinkService } from 'app/services/landing-link.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    footerDocuments: any[] = [];

    constructor(
        private unitService: UnitPublicService,
        public landing: LandingLinkService,
    ) {}

    ngOnInit(): void {
        this.unitService.getGlobalDocuments().subscribe((docs: any[]) => {
            docs.forEach((doc) => {
                doc.showOnPages.forEach((pageType) => {
                    if (pageType === 'footer') {
                        this.footerDocuments.push(doc);
                    }
                });
            });
        });
    }

    openDocument(doc) {
        this.unitService.openPublicDocument(doc._id).subscribe((_data: any) => {
            var newBlob = new Blob([_data], { type: FileDownloaderUtils.getMimeType(doc.name) });
            const data = window.URL.createObjectURL(newBlob);

            var link = document.createElement('a');
            link.href = data;
            link.target = '_blank';
            link.rel = 'noopener';
            link.download = doc.originalname;
            window.open(link.href);
        });
    }
}
